"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATIONS_RESOURCES = exports.TRANSLATIONS_LANGUAGES = void 0;

var _translationResources_EN_CA = _interopRequireDefault(require("./translationResources_EN_CA.js"));

var _translationResources_EN_UK = _interopRequireDefault(require("./translationResources_EN_UK.js"));

var _translationResources_EN_IE = _interopRequireDefault(require("./translationResources_EN_IE.js"));

var _translationResources_FR_CA = _interopRequireDefault(require("./translationResources_FR_CA.js"));

var _TRANSLATIONS_RESOURC;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TRANSLATIONS_LANGUAGES = {
  en_CA: "en-CA",
  en_UK: "en-UK",
  en_IE: "en-IE",
  fr_CA: "fr-CA"
};
exports.TRANSLATIONS_LANGUAGES = TRANSLATIONS_LANGUAGES;
var TRANSLATIONS_RESOURCES = (_TRANSLATIONS_RESOURC = {}, _defineProperty(_TRANSLATIONS_RESOURC, TRANSLATIONS_LANGUAGES.en_CA, _translationResources_EN_CA.default), _defineProperty(_TRANSLATIONS_RESOURC, TRANSLATIONS_LANGUAGES.en_UK, _translationResources_EN_UK.default), _defineProperty(_TRANSLATIONS_RESOURC, TRANSLATIONS_LANGUAGES.en_IE, _translationResources_EN_IE.default), _defineProperty(_TRANSLATIONS_RESOURC, TRANSLATIONS_LANGUAGES.fr_CA, _translationResources_FR_CA.default), _TRANSLATIONS_RESOURC);
exports.TRANSLATIONS_RESOURCES = TRANSLATIONS_RESOURCES;